import { contactHero } from '@/mocks/contactData';
import { img, readdy } from '@/utils/images';
import ScrollReveal from '@/components/base/ScrollReveal';

export default function ContactHero() {
  return (
    <section className="relative w-full h-[420px] md:h-[560px] overflow-hidden">
      <div className="absolute inset-0 bg-brand-deep">
        <div className="absolute inset-0 opacity-15">
          <img
            src={readdy('contact-hero-bg')}
            alt=""
            className="w-full h-full object-cover object-top"
          />
        </div>
      </div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-6 md:px-10">
        <ScrollReveal variant="fade-down">
          <p className="text-brand-gold/60 text-xs tracking-[0.3em] mb-4 font-medium uppercase">
            {contactHero.subtitle}
          </p>
        </ScrollReveal>
        <ScrollReveal variant="fade-up" delay={100}>
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 leading-tight">
            {contactHero.title}
          </h1>
        </ScrollReveal>
        <ScrollReveal variant="fade-up" delay={200}>
          <p className="text-white/50 text-sm md:text-base max-w-lg leading-relaxed">
            {contactHero.description}
          </p>
        </ScrollReveal>
      </div>
    </section>
  );
}